import { Editor, Element as SlateElement } from "slate";
import {
  CustomEditor,
  CustomElement,
  ListItemElement,
  NumberedList,
  BulletedList
} from "./types";

export const compose = <R>(fn1: (a: R) => R, ...fns: Array<(a: R) => R>) =>
  fns.reduce((prevFn, nextFn) => value => prevFn(nextFn(value)), fn1);

export const getElementsByType = <T extends CustomElement["type"]>(
  editor: CustomEditor,
  type: T
) => {
  // TODO: refactor:
  type WhichElement = T extends "list-item"
    ? ListItemElement
    : T extends "bulleted-list"
    ? BulletedList
    : T extends "numbered-list"
    ? NumberedList
    : CustomElement;

  return Array.from(
    Editor.nodes(editor, {
      match: node =>
        !Editor.isEditor(node) &&
        SlateElement.isElement(node) &&
        node.type === type
    })
  ) as [WhichElement, number[]][];
};

export const getSelectedElements = (editor: CustomEditor) => {
  if (!editor.selection) return null;

  return Array.from(
    Editor.nodes(editor, {
      match: node =>
        !Editor.isEditor(node) && SlateElement.isElement(node) && "type" in node
    })
  ) as [CustomElement, number[]][];
};

export const isValidSelection = (
  editor: CustomEditor,
  selection: CustomEditor["selection"]
): selection is NonNullable<CustomEditor["selection"]> => {
  if (!selection) return false;

  try {
    Editor.leaf(editor, selection);
    return true;
  } catch {
    return false;
  }
};

export const isActiveElementOfType = (
  editor: CustomEditor,
  type: CustomElement["type"]
) => {
  return !!getElementsByType(editor, type).pop();
};
